import { u as url, t as getNavigationState } from './helpers-cd261aee.js';
import { i as isV3, $ as getBrandName } from './index-39f51a91.js';
import { j as join } from './path-3461bbf6.js';

const ID_REGEXP = /^\d+/;
const LOCALE_REGEXP = /\/[a-z]{2}(?:-[a-z]{2})?(?=(?:\/|$))/gi;
const PRODUCT_RANGE_SEGMENT = 'product-range/';
const RANGE_ENDPOINT = 'product/';

const getSelectorConfigUrl = (host, rangeId, isHostAbsolutePath) => {
  const localArr = host.split('/');
  const countryCode = localArr[localArr.length - 2];
  const languageCode = localArr[localArr.length - 1];
  const brandName = getBrandName();
  if (isV3()) {
    return `/ranges/${rangeId}/selector-config?country-code=${countryCode}&language-code=${languageCode}&brand=${brandName}`;
  }
  if (isHostAbsolutePath) {
    return `${host}/${join('product/range/selector-config', rangeId)}`;
  }
  return join(host, 'product/range/selector-config', rangeId);
};
const getFiltersUrl = (host, endpoint, rangeId, navigationState, nodeId, categoryId) => url.format({
  pathname: join(host, endpoint, 'api/range/filters', rangeId, nodeId || '', categoryId || ''),
  query: Object.assign({}, (navigationState.includes('subnode-id')
    ? { 'subnode-id': navigationState.replace('?subnode-id=', '') }
    : { n: getNavigationState(navigationState) })),
});

export { ID_REGEXP as I, LOCALE_REGEXP as L, PRODUCT_RANGE_SEGMENT as P, RANGE_ENDPOINT as R, getFiltersUrl as a, getSelectorConfigUrl as g };
